// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"498":"12f6524e","835":"1aa28d11"}[chunkId] + ".css";
};